import { render, staticRenderFns } from "./MenuModal.vue?vue&type=template&id=43bb1e05&scoped=true&"
import script from "./MenuModal.vue?vue&type=script&lang=ts&"
export * from "./MenuModal.vue?vue&type=script&lang=ts&"
import style0 from "./MenuModal.vue?vue&type=style&index=0&id=43bb1e05&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43bb1e05",
  null
  
)

export default component.exports